
import React, { useState } from "react";
import { Link , useNavigation  } from "react-router-dom";

import Settings from "../../view/settings/settings";

import "./layout.css";

const Layout = ({ children ,  menuItem=[] , location }) => {
  const [collapsed, setCollapsed] = useState(false);

  const [ settingsSwitch , setSettingsSwitch ] = useState(false)

  return (
    <>
      <div className="layout-container">
      
      <div className={`left-side ${collapsed ? "collapsed" : ""}`}>
        
    <div className="sidebar-header">
  {!collapsed && <h3 className="sidebar-title">Arcsine Analytics</h3>}

  <div className="header-actions" style={{marginLeft:`${collapsed ? "0px":"-20px"}`}}>
    {/* Settings Button */}
    <button
      className="toggle-btn"
      onClick={() => { setSettingsSwitch( pre => !pre ) }}
    >
      <i className="fa-solid fa-gear color"></i>
    </button>

    {/* Toggle Button */}
    <button
      className="toggle-btn"
      onClick={() => setCollapsed(!collapsed)}
    >
      <i
        className={`fa ${
          collapsed
            ? "fa-solid fa-circle-arrow-right color"
            : "fa-solid fa-circle-arrow-left color"
        }`}
      ></i>
    </button>
  </div>
</div>

        {/* Sidebar Content */}
        {(
          <div className="sidebar-content">
            {
                menuItem.map( item =>{
                    return(
                        <Link to={item.path} className={`sidebar-link ${collapsed ? "link-col" : ""} ${location === item.path ?"link-active" : ""} `}>  
                         {
                          item.icon
                         }
                         {
                            collapsed ? "" :  <span>{item.name}</span>
                         }
                        </Link>
                    )
                } )
            }
          </div>
        )}

      </div>

      <div className={ `right-side ${collapsed ? "grow" : "ori"}` }>
      {
         children
      }
         
      </div>

    </div>
    {
      settingsSwitch &&
    <>
        <Settings onClose={()=>{setSettingsSwitch( false )}}/>
    </>
    }
    </>
  );
};

export default Layout;
